import { cmpDialog } from '../cmp-dialog';
import { lloadDisqus, translate, executeAsync } from '../utils/fn';
import { loadGallery } from './msnt-photo-gallery-helper';
import device from 'current-device';

export const msntPhotoThumbGallery = selector => {
  var selector = selector || '.msnt-photo-thumb-gallery';
  var $dataEdtn = $('body').data('edtn');
  var showDisqusButton = $('#show-disqus');
  var ifVisible = showDisqusButton.data('visible');
  var lloadDisqusEditions = ['us', 'ev_us', 'it', 'de', 'fr', 'id', 'ru', 'ev_fr', 'ev_it', 'ev_ru', 'om', 'ra_us'];
  $('.msnt-photo-thumb-gallery-main-photo-box').on('click', function(event) {
    event.preventDefault();

    let $target = $(this)
      .closest('.msnt-photo-thumb-gallery')
      .find('.msnt-photo-thumb-gallery-photos-list .lslide.active');

    $target.trigger('click');
  });

  $(selector + ' .msnt-photo-thumb-gallery-photos-list').lightSlider({
    pager: false,
    autoWidth: true,
    rtl: $('body').data('rtl'),
    slideMargin: 5,
    enableDrag: false,
    onSliderLoad: function($el) {
      if ($el.data('slider-hash')) {
        var fragment = document.location.hash.replace(/[^a-zA-Z_0-9-\/]/g, '');
        if (fragment) {
          var isFullSize = fragment.lastIndexOf('full-size/');
          if (isFullSize !== -1) {
            fragment = fragment.substr(0, isFullSize);
            if (fragment === '') {
              history.replaceState(
                {},
                null,
                document.location.href.replace('#full-size/', '')
              );
              setTimeout(function() {
                $(selector)
                  .find('.msnt-photo-thumb-gallery-main-photo-box')
                  .trigger('click');
              }, 10);
            } else {
              history.replaceState(
                {},
                null,
                document.location.href.replace('full-size/', '')
              );
            }
            isFullSize = true;
          } else {
            isFullSize = false;
          }
          if (fragment) {
            var $currentSlide = $el.find('[data-hash="' + fragment + '"]');
            if ($currentSlide.length) {
              var $mainPhoto = $(selector).find(
                '.msnt-photo-thumb-gallery-main-photo-box'
              );
              var $mainPhotoImage = $mainPhoto.find('img');
              var src = $currentSlide.data('src');
              var href = $currentSlide.data('url');
              if ($mainPhoto.length && $mainPhotoImage.length && src && href) {
                $el.goToSlide($currentSlide.index());
                $mainPhoto.attr('href', href);
                $mainPhotoImage.attr('src', src);
              }
              if (isFullSize) {
                setTimeout(function() {
                  $currentSlide.trigger('click');
                }, 10);
              }
            }
          }
        }
      }
    },
  });

  let hash = document.location.hash,
    $gallerys = $('.msnt-photo-thumb-gallery-photos-list'),
    $sectionImg;

  if (hash && !$gallerys.data('slider-hash')) {
    let dataHash = hash.replace(/[^a-zA-Z_0-9-\/]/g, ''),
      arrayOfHash = dataHash.split('/'),
      galleryCollection = getGallerysCollection(
        $gallerys,
        arrayOfHash[1],
        null
      );

      if(dataHash == 'comments') {
        scroll(0,0);
        setTimeout(function(){scroll(0,0);},1);
        // console.log('i am here');
        // console.log(hash);

        // $('html,body').animate({
        //   scrollTop:$(hash).offset().top + 500
        // },500);

        // var anchor = string[stringLength-1];

        var distanceToAnchor = $(hash).offset().top;
        var distanceToAnchorNew;
        var callTimes = 0;
        // console.log(distanceToAnchor);

        $('html, body').animate({
          scrollTop: $(hash).offset().top + 500
        }, 500);

        const resizeObserver = new ResizeObserver((entries, observer) => {
          for(let entry of entries){
              if (callTimes < 8) {
                calcResizeTimes();
              } else {
                resizeObserver.unobserve(document.querySelector('#post_box'));
                resizeObserver.unobserve(document.querySelector('#container_3rd_party_service'));
              }
          }
        })
        
        resizeObserver.observe(document.querySelector('#post_box'));
        resizeObserver.observe(document.querySelector('#container_3rd_party_service'));
    
        function calcResizeTimes() {
          distanceToAnchorNew = $(hash).offset().top + 500;
    
          if(distanceToAnchor != distanceToAnchorNew) {
            $('html, body').animate({
              scrollTop: distanceToAnchorNew
            }, 500);
          }
          callTimes++;
        }

        if (lloadDisqusEditions.includes($dataEdtn) && ifVisible) {
          lloadDisqus();
          showDisqusButton.data('visible', false);
          showDisqusButton.hide();
        }
      }
    // console.log(dataHash);
    // console.log(arrayOfHash);
    // console.log('maybe I am here');
    history.replaceState({}, null, document.location.href.replace(hash, ''));

    if (!galleryCollection) return;

    let galleryId = galleryCollection.galleryId;

    if (galleryId == null) {
      let photoId = galleryCollection.photoIds;

      $sectionImg = $(
        'section[data-widget="image"][data-id="' + photoId + '"]'
      ).first();

      executeAsync(() => {
        $sectionImg.trigger('click');
      });
    }

    let $gallery = $(
        '.msnt-photo-thumb-gallery-photos-list[data-galleryid="' +
          galleryId +
          '"]'
      ).first(),
      $galleryItem = $gallery.find(
        '.lslide[data-entity-id="' + arrayOfHash[1] + '"]'
      ),
      $galleryItemFirst = $(
        '.msnt-photo-thumb-gallery-photos-list[data-galleryid="' +
          galleryId +
          '"] .lslide'
      ).first(),
      offsetTop;

    if ($gallery.length != 0) {
      offsetTop = $gallery.closest('.msnt-photo-thumb-gallery').offset().top;
    } else {
      offsetTop = $('#container_3rd_party_service').offset().top;
    }

    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual';
    }

    $('html, body').animate(
      {
        scrollTop: offsetTop,
      },
      0
    );

    if ($gallery.length != 0) {
      $gallery.attr({
        'data-ampgalleryid': galleryId,
        'data-ampphotoid': arrayOfHash[1],
      });

      executeAsync(() => {
        let itemClick =
          $galleryItem.length != 0 ? $galleryItem : $galleryItemFirst;
        itemClick.trigger('click');
      });
    }
  }

  $('.lslide, section[data-widget="image"][data-id]').on('click', function(
    event
  ) {
    event.preventDefault();

    window.successResponse = true;

    let $this = $(this),
      clossestPhotoLists = $this.closest(
        '.msnt-photo-thumb-gallery-photos-list'
      ),
      photoId =
        clossestPhotoLists.data('ampphotoid') ||
        $this.data('id') ||
        $this.data('entity-id'),
      typeGallery = clossestPhotoLists.data('type-gallery'),
      galleryCollection = getGallerysCollection(
        $gallerys,
        photoId,
        typeGallery
      ),
      api = 'api';

    if (!galleryCollection) return;

    let galleryId = galleryCollection.galleryId,
      indexOf = galleryCollection.indexOf,
      $galleryList = $(
        '.msnt-photo-thumb-gallery-photos-list[data-galleryid="' +
          galleryId +
          '"]'
      ).first(),
      onMobileOff = document.documentElement.clientWidth < 768 ? false : true,
      onMobileLandscapeOff = false;

      if (device.type == 'mobile' && device.orientation !== 'portrait') {
        onMobileLandscapeOff = false;
      } else {
        onMobileLandscapeOff = true;
      }

    if (photoId == 'aditational-photo') {
      let $childs = $this.parent().children();

      indexOf = $childs.index(this);

      $galleryList = $this.closest('.msnt-photo-thumb-gallery-photos-list');
      galleryId = $galleryList.data('galleryid');
    } else if (galleryId == undefined && !typeGallery) {
      api = 'api2';
      galleryId = photoId;
      $galleryList = $this;
    }

    let preloader = $('.preloader');

    if (preloader.length == 0) {
      $this.append(`<div class="preloader responsive" style="display: none;">
      <div class="spinner_loader"></div>
      </div>`);
      $('.preloader').fadeIn('slow');
    }

    if (!window.successResponse) return;
    window.successResponse = false;

    let url;

    if (typeGallery) {
      url = `/buy/${typeGallery}/${galleryId}/photos/`;
    } else {
      url = `/photos/${api}/${galleryId}/`;
    }

    let langs = $('body').data().edtn,
            configAdditation = ['ra_us', 'of', 'ev_us', 'ev_it', 'ev_fr', 'ev_br', 'ac', 'ev_de', 'ev_tr', 'ev_ru', 'ot', 'ev_ar'],
            prefix = configAdditation.includes(langs) ? langs : 'us';

    $.get({
      url: url,
      success: function(data) {
        let arrayPhotos = [];

        $('.preloader').remove();

        if (!data.status) {
          window.successResponse = true;
          return cmpDialog.content('Sorry service unavailable try again later');
        }

        const skipIndex = 5;
        let adIndex;

        for (let index = 0; index < data.photos.length; index++) {          
          if ((index == 3 || index == adIndex) && device.type == 'mobile' && data.ads_banner) {
            arrayPhotos.push({
              src: data.ads_banner,
              thumb: `/design/images/${prefix}_logo_gallery.svg`,
              adSlide: true
            });

            adIndex = index;
            adIndex += skipIndex;
          }

          let finalAuthorTitle = data.photos[index].author_title
            ? '(' +
              translate('photo_by', 'Photo by') +
              ' ' +
              data.photos[index].author_title +
              ')'
            : '';
          
          let subHtml = data.photos[index].title + ' ' + finalAuthorTitle;

          let sizeImg = onMobileOff
            ? data.photos[index].big
            : typeGallery && onMobileOff
            ? data.photos[index].large
            : data.photos[index].middle;

          arrayPhotos.push({
            src: sizeImg,
            thumb: typeGallery ? data.photos[index].middle : data.photos[index].small,
            caption: data.photos[index].caption || null,
            title: data.photos[index].title || null,
            subHtml: data.car_title || subHtml,
            url: data.photos[index].url || null,
            entityId:data.photos[index].photo_edition_id || null,
            hor: data.photos[index].hor,
            description: data.photos[index].description,
            downloadUrl: data.photos[index].big,
            photoNumber: index
          });
        }

        if ((api = 'api2')) {
          arrayPhotos.forEach((element, index) => {
            if (element.entityId == photoId) {
              indexOf = index;
            }
          });
        }

        // let langs = $('body').data().edtn,
        //     configAdditation = ['ra_us', 'of', 'ev_us', 'ev_it', 'ev_fr', 'ev_br', 'ac'],
        //     prefix = configAdditation.includes(langs) ? langs : 'us';

        if (data.additional_slide) {
          arrayPhotos.push({
            src: data.additional_slide,
            thumb: `/design/images/${prefix}_logo_gallery.svg`,
            htmlSlide: true,
          });
        }

        loadGallery({
          arrayPhotos: arrayPhotos, 
          galleryId: galleryId, 
          indexOf: indexOf, 
          $galleryList: $galleryList, 
          onMobileOff: onMobileOff,
          onMobileLandscapeOff: onMobileLandscapeOff,
          additionalParams: {
            dynamicGallery: true
          }
        });
      },
    });
  });


  function getGallerysCollection($gallerys, photoId, typeGallery) {
    if ($gallerys.lenght == 0) return;

    let galleryCollection = [];

    $gallerys.each(function(indexGallery, elementGallery) {
      if (elementGallery.dataset.photoIds) {
        let photoIds = elementGallery.dataset.photoIds.split(',');

        photoIds.forEach((elementId, elementIndex) => {
          if (photoId == elementId) {
            galleryCollection.push({
              galleryId: elementGallery.dataset.galleryid,
              photoIds: elementId,
              indexOf: elementIndex,
            });
          }
        });
      } else if (typeGallery) {
        galleryCollection.push({
          galleryId: elementGallery.dataset.galleryid,
          typeGallery: typeGallery,
        });
      }
    });

    if (galleryCollection.length == 0) {
      galleryCollection = [
        {
          galleryId: null,
          photoIds: photoId,
        },
      ];
    }

    return galleryCollection[0];
  }
};
